import { render, staticRenderFns } from "./despatch.vue?vue&type=template&id=3f155391&"
import script from "./despatch.vue?vue&type=script&lang=js&"
export * from "./despatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports